export const TERTIARY = {
  DARKEST: '#425A00',
  DARKER: '#698128',
  DARK: '#85A136',
  DEFAULT: '#9BBE3C',
  LIGHT: '#DDE995',
  LIGHTER: '#EAF6B9',
  LIGHTEST: '#F6FAE7',
} as const;
